import { render, staticRenderFns } from "./ProductionArea.vue?vue&type=template&id=2a005af0&scoped=true&lang=pug&"
import script from "./ProductionArea.vue?vue&type=script&lang=js&"
export * from "./ProductionArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a005af0",
  null
  
)

export default component.exports